__turbopack_context__.v({
  "badge": "badge-module-scss-module__dSJBkW__badge",
  "badge--secondary": "badge-module-scss-module__dSJBkW__badge--secondary",
  "badge--tertiary": "badge-module-scss-module__dSJBkW__badge--tertiary",
  "badge__icon-container": "badge-module-scss-module__dSJBkW__badge__icon-container",
});
